export const onlyWordsChecker = (value: string) => {
    if (!value) {
        return value
    }
    const re = new RegExp("^[\\w-]*$")
    if (re.test(value)) {
        return value
    }
    return false
}